document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
      alert('🚫 No está permitido hacer clic derecho en esta página.');
    });

document.addEventListener('keydown', (event) => {
    if (
        event.key === 'F12' || // tecla F12
        ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I') || // Ctrl + Shift + I
        ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'J') || // Ctrl + Shift + J
        ((event.ctrlKey || event.metaKey) && event.keyCode === 85) || // Ctrl + U (ver código fuente)
        ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'C') 
    ) {
        event.preventDefault();
        alert('🚫 Acción no permitida.');
    }else if (event.ctrlKey && event.key.toLowerCase() === 's' || (event.ctrlKey || event.metaKey) && key.toLowerCase() === 's') {
        event.preventDefault();
        alert('🚫 Guardar página está deshabilitado.');
    }else if(event.key === 'PrintScreen' || event.key === 'Snapshot'){
        event.preventDefault();
        alert('Las capturas de pantalla están deshabilitadas.');

        navigator.clipboard.writeText('')
        .then(() => {
            console.log('Portapapeles limpiado.');
        })
        .catch(err => {
            console.error('Error al limpiar el portapapeles:', err);
        });
    }
});


